export const routeKey = {
    dauGuid: 'dauGuid',
    pamGuid: 'pamGuid',
    key: 'key',
    isTab: 'isTab'
} as const;

export type RouteKey = typeof routeKey[keyof typeof routeKey];
    